export const createOptionsElement = (label, value = "not found") => ({ label, value });
